// Path of the CMS content behind the header "Descargas" link
// (/contenido/descargas).
export const DOWNLOADS_PATH = '/descargas'

// The header shows the "Descargas" link only when the shop has active content
// with that path, its own or a shared one: `paths` comes from
// /v1/content/fetch-slugs/. Without that content, no link.
export const hasDownloads = (paths) =>
  Array.isArray(paths) && paths.includes(DOWNLOADS_PATH)
